import Contacts from "./Contacts"
import Organization from "./Organizations"
import ActiveClients from "./ActiveClients"
import ListTypes from "./ListTypes"
import BenchEmployees from "./Employees/BenchEmployees"
import ShortlistedEmployee from "./Employees/ShortlistedEmployees"
import Leads from "./Leads"
import LeadDetailView from "./LeadDetails"
import Stages from "./Stages"
import CandidateOverview from "../hrm/pre-onboardig/EmployeeDetails"
import LeadAccounts from "./Accounts/Accounts"
import Deals from "./Deals"
import TaskManagement from "./Tasks/TaskManagement"
import BDETasks from "./Tasks/BDETasks"
import CallLogs from "./CallLogs/CallLogs"
import { ActivityDetails } from "../Activities"
import QuotesComponent from "./Quotes/QuotesComponent"
import BillableDevelopers from "./Developers/BillableDevelopers"
import BenchDevelopers from "./Developers/BenchDevelopers"
import BankAccounts from "./Invoices/Settings/BankAccounts"
import InvoiceNumber from "./Invoices/Settings/InvoiceNumber"
import GenralSettings from "./Invoices/Settings/GeneralSetting"
import SalaryVsSalesDashboard from "./Analytics/SalaryVSSales"
import ContractInterviews from "./Interviews/ContractInterviews"
import Calender from "./Calender"
import Feedback from "./Feedback"

export default {
    Contacts,
    Organization,
    ActiveClients,
    ListTypes,
    BenchEmployees,
    ShortlistedEmployee,
    Leads,
    LeadDetailView,
    Stages,
    CandidateOverview,
    LeadAccounts,
    Deals,
    TaskManagement,
    BDETasks,
    CallLogs,
    QuotesComponent,
    BillableDevelopers,
    BenchDevelopers,
    BankAccounts,
    InvoiceNumber,
    GenralSettings,
    SalaryVsSalesDashboard,
    ContractInterviews,
    Calender,
    Feedback
}